/* eslint-disable */
import { getCookie } from '@/utils/cookie'

export const sendFormDataToMindbox = async ({
  email,
  isSubscribed = 'true',
  parentName,
  phone,
}) => {
  const deviceUUID = getCookie('mindboxDeviceUUID')

  if (!deviceUUID) {
    console.error('Mindbox DeviceUUID does not exist')
    return
  }

  const url = `https://api.mindbox.ru/v3/operations/async?endpointId=algoritmika.Website&operation=AplicationSent&deviceUUID=${deviceUUID}`

  const payload = {
    customer: {
      email,
      fullName: parentName,
      mobilePhone: phone,
      subscriptions: [
        {
          brand: 'algoritmika',
          isSubscribed,
          pointOfContact: 'Email',
        },
        {
          brand: 'algoritmika',
          isSubscribed,
          pointOfContact: 'SMS',
        },
      ],
    },
  }

  await fetch(url, {
    body: JSON.stringify(payload),
    headers: {
      Accept: 'application/json',
      Authorization: 'Mindbox secretKey="xhRl7U09ZKH1V8QNs5gslXK2JRKqSk1L"',
      'Content-Type': 'application/json; charset=utf-8',
    },
    method: 'POST',
  })
    .then((response) => response.json())
    .catch((error) => {
      console.error('Fetch Mindbox error', error)
    })
}
